import React from 'react';
import PropTypes from 'prop-types';
import { source } from 'react-aim';
import CategoryItem2List from './CategoryItem2List';
import AppService from '../service/AppService';
import type AppConfig from '../domain/AppConfig';
import AppConfigService from '../service/AppConfigService';
const appConfig:AppConfig = AppService.appConfig();

@source({
  mouseEnter: (props, component) => component.setState({ over: true }),
  mouseLeave: (props, component) => component.setState({ over: false })
})
export default class CategoryItem1 extends React.Component {

  static propTypes = {
    productCategory: PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayCategoryId: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      disableMarketplaceBanner: PropTypes.bool,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { over: false };
  }

  onClick() {
    let {
      name,
      displayCategoryId,
    } = this.props.productCategory;

    if (!this.props.disableMarketplaceBanner) {
      window.location.href = `${appConfig.marketplaceWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${displayCategoryId}&k=`;
    } else if (AppConfigService.shouldShowMarketplaceTopBanner()) {
      window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/s/item/?rf=1108&fc=%7C${displayCategoryId}&k=`;
    } else {
      window.location.href = `${appConfig.searchWebHost}/${appConfig.langCode}/c/1/${encodeURIComponent(name)}/${displayCategoryId}/index.html`;
    }
  }

  render() {

    let {
      name,
      displayCategoryId,
      itemCount,
    } = this.props.productCategory;

    let { over } = this.state;

    let nameStyle = {};
    let layer2 = undefined;
    if (over) {
      layer2 = <CategoryItem2List productCategory={this.props.productCategory} disableMarketplaceBanner={this.props.disableMarketplaceBanner} />
      nameStyle = {color: '#007ca0'};
    }

    let imageUrl = `/common/images/category/${displayCategoryId}.png`;
    imageUrl = AppService.staticUrl(imageUrl);


    return (
      <div className="categoryItemContainer">
        <a className="categoryItem">
          <img src={imageUrl} />
          <p className="name" onClick={::this.onClick}>
            <span style={nameStyle}>{name}</span>
            {itemCount && <span className="number">({itemCount.toLocaleString('en')})</span>}
          </p>
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </a>
        {layer2}
      </div>
    )
  }

}